<dx-scroll-view #workflowScrollView width="100%" height="100%" (onInitialized)="onScrollViewInitialize()">
    <dx-box
        #workflow
        width="100%"
        height="85vh"
        direction="col"
        class="workflow-box cc-white-background"
        [elementAttr]="{ id: 'workflowDataEntry' }"
    >
        <dxi-item [ratio]="1" class="each-item">
            <div *dxTemplate>
                <dx-responsive-box width="100%" height="100%" class="invoice-reponsive-box cc-invoice-reponsive-box">
                    <dxi-row></dxi-row>
                    <dxi-row></dxi-row>
                    <dxi-row></dxi-row>
                    <dxi-row></dxi-row>
                    <dxi-row></dxi-row>

                    <dxi-col [ratio]="1"></dxi-col>
                    <dxi-col [ratio]="1"></dxi-col>

                    <dxi-item>
                        <dxi-location [row]="0" [col]="0"></dxi-location>

                        <div *dxTemplate>
                            <div class="row-container">
                                <div class="first-item">
                                    <div class="field-label">AAP Workflow#</div>
                                    <div class="field-component">{{ workflowId }}</div>
                                </div>
                            </div>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxi-location [row]="0" [col]="1"></dxi-location>
                        <div *dxTemplate>
                            <div class="row-container">
                                <div class="column-container">
                                    <div class="selected-editor-information">
                                        Current Status:&nbsp; {{ workFlowEditor?.status }}
                                    </div>
                                </div>

                                <div class="button-component-container">
                                    <dx-button
                                        class="workflow-setting-button cc-dummy-button"
                                        location="after"
                                        hint="Settings"
                                        type="default"
                                        [tabIndex]="-1"
                                    >
                                        <div *dxTemplate="let data of 'content'">
                                            <div>
                                                <i title="Click to view settings" class="fas fa-cog"></i>
                                            </div>
                                            <dx-context-menu
                                                target=".workflow-setting-button"
                                                showEvent="dxclick"
                                                [position]="{ my: 'top center', at: 'bottom center' }"
                                                [items]="settingsMenu"
                                            ></dx-context-menu>
                                        </div>
                                    </dx-button>
                                </div>
                            </div>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxi-location [row]="1" [col]="0"></dxi-location>
                        <div *dxTemplate>
                            <div class="row-container">
                                <div class="first-item">
                                    <div
                                        class="field-label"
                                        [ngClass]="{
                                            'dx-theme-text-color': workFlowEditor?.allowProcessing,
                                            'dx-theme-border-color-as-text-color': !workFlowEditor?.allowProcessing
                                        }"
                                    >
                                        Community
                                        <sup class="field-star">*</sup>
                                    </div>
                                    <div class="field-component">
                                        <app-multi-column-selector
                                            #communitySelector
                                            [disabled]="!workFlowEditor?.allowProcessing"
                                            [name]="'Community'"
                                            [gridSource]="communityGridSource"
                                            [boxValue]="communityGridBoxValue"
                                            [valueExpr]="'communityId'"
                                            [displayExpr]="'communityName'"
                                            [columnDef]="communityColumns"
                                            [dropDownButtonTemplate]="'dropDownButton'"
                                            [dropDownOptions]="{ width: 700 }"
                                            [showClearButton]="true"
                                            [navigateToCommunity]="true"
                                            [placeholder]="'Select Community...'"
                                            [showHeaderFilters]="true"
                                            (gridSelectionEvent)="onCommunitySelection($event)"
                                        ></app-multi-column-selector>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxi-location [row]="1" [col]="1"></dxi-location>
                        <div *dxTemplate>
                            <div class="column-container">
                                <div
                                    class="selected-editor-information"
                                    [ngClass]="{
                                        'dx-theme-text-color': isCommunitySelected,
                                        'dx-theme-border-color-as-text-color': !isCommunitySelected
                                    }"
                                >
                                    Location:&nbsp; {{ selectedCommunity?.locationName }}
                                </div>
                                <div
                                    class="selected-editor-information"
                                    [ngClass]="{
                                        'dx-theme-text-color': isCommunitySelected,
                                        'dx-theme-border-color-as-text-color': !isCommunitySelected
                                    }"
                                >
                                    Management Company: &nbsp;{{ selectedCommunity?.managementCompanyName }}
                                </div>
                            </div>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxi-location [row]="2" [col]="0"></dxi-location>
                        <div *dxTemplate>
                            <div class="row-container">
                                <div class="first-item">
                                    <div
                                        class="field-label"
                                        [ngClass]="{
                                            'dx-theme-text-color': isCommunitySelected,
                                            'dx-theme-border-color-as-text-color':
                                                !isCommunitySelected || !workFlowEditor?.allowProcessing
                                        }"
                                    >
                                        Payee Type
                                        <sup class="field-star">*</sup>
                                    </div>
                                    <div class="field-component">
                                        <dx-radio-group
                                            layout="horizontal"
                                            displayExpr="displayName"
                                            valueExpr="value"
                                            [tabIndex]="-1"
                                            [disabled]="!isCommunitySelected || !workFlowEditor?.allowProcessing"
                                            [dataSource]="payeeOptions"
                                            [value]="selectedPayee"
                                            [elementAttr]="{ class: 'radio-group' }"
                                            (onValueChanged)="onPayeeTypeChanged($event)"
                                        ></dx-radio-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxi-location [row]="2" [col]="1"></dxi-location>
                        <div *dxTemplate>
                            <div class="button-row-container">
                                <div *ngIf="separateWindow" class="icon-button-content">
                                    <i
                                        title="Show PDF"
                                        class="cc-icon-pdf icon-pdf-button"
                                        [ngClass]="iconPDF"
                                        (click)="onPdfClick()"
                                    ></i>
                                </div>

                                <div *ngIf="!!workFlowEditor.hasNotes" class="icon-button-content">
                                    <i
                                        title="AAP Workflow Notes"
                                        class="cc-icon-check icon-button"
                                        [ngClass]="iconNotes"
                                        (click)="onWorkflowNotesClick()"
                                    ></i>
                                </div>
                                <div *ngIf="!workFlowEditor.hasNotes" class="icon-button-content">
                                    <i
                                        title="AAP Workflow Notes"
                                        class="dx-theme-accent-as-text-color icon-button"
                                        [ngClass]="iconEmptyNotes"
                                        (click)="onWorkflowNotesClick()"
                                    ></i>
                                </div>
                                <div class="button-content">
                                    <dx-button
                                        type="default"
                                        text="AAP Workflow History"
                                        [icon]="iconHistory"
                                        [tabIndex]="-1"
                                        [elementAttr]="{ class: 'button-size' }"
                                        (onClick)="onWorkflowHistoryClick()"
                                    ></dx-button>
                                </div>
                            </div>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxi-location [row]="3" [col]="0"></dxi-location>
                        <div *dxTemplate>
                            <div class="row-container">
                                <div class="first-item">
                                    <div
                                        class="field-label"
                                        [ngClass]="{
                                            'dx-theme-text-color': isCommunitySelected,
                                            'dx-theme-border-color-as-text-color':
                                                !isCommunitySelected || !workFlowEditor?.allowProcessing
                                        }"
                                    >
                                        Payee
                                        <sup class="field-star">*</sup>
                                    </div>
                                    <div *ngIf="selectedPayee === 'VENDOR'" class="field-component">
                                        <app-multi-column-selector
                                            #vendorPayeeSelector
                                            [name]="'Vendor'"
                                            [disabled]="!isCommunitySelected || !workFlowEditor?.allowProcessing"
                                            [isItemSelectionMandatory]="true"
                                            [gridSource]="payeeVendorBoxGridSource"
                                            [boxValue]="payeeVendorGridBoxValue"
                                            [dropDownButtonTemplate]="'dropDownEditButton'"
                                            [dropDownOptions]="{ width: 700 }"
                                            [valueExpr]="'vendorCode'"
                                            [displayExpr]="'vendorName'"
                                            [columnDef]="vendorPayeeColumns"
                                            [showClearButton]="false"
                                            [placeholder]="'Search Vendor...'"
                                            (gridSelectionEvent)="onVendorPayeeSelection($event)"
                                            (editTemplateEvent)="onVendorEditClick()"
                                        ></app-multi-column-selector>
                                    </div>

                                    <div *ngIf="selectedPayee === 'OWNER'" class="field-component">
                                        <app-multi-column-selector
                                            #ownerPayeeSelector
                                            [name]="'Owner'"
                                            [disabled]="!isCommunitySelected || !workFlowEditor?.allowProcessing"
                                            [gridSource]="payeeOwnerBoxGridSource"
                                            [boxValue]="payeeOwnerGridBoxValue"
                                            [dropDownButtonTemplate]="'dropDownButton'"
                                            [dropDownOptions]="{ width: 700 }"
                                            [valueExpr]="'customerId'"
                                            [displayExpr]="'ownerName'"
                                            [columnDef]="ownerPayeeColumns"
                                            [showClearButton]="true"
                                            [placeholder]="'Search Owner...'"
                                            (gridSelectionEvent)="onOwnerPayeeSelection($event)"
                                        ></app-multi-column-selector>
                                    </div>

                                    <div *ngIf="selectedPayee === 'COMMUNITY'" class="field-component">
                                        <app-multi-column-selector
                                            #communityPayeeSelector
                                            [name]="'Community'"
                                            [disabled]="!isCommunitySelected || !workFlowEditor?.allowProcessing"
                                            [gridSource]="payeeCommunityBoxGridSource"
                                            [boxValue]="payeeCommunityGridBoxValue"
                                            [dropDownButtonTemplate]="'dropDownButton'"
                                            [dropDownOptions]="{ width: 700 }"
                                            [valueExpr]="'intacctCompanyId'"
                                            [displayExpr]="'communityName'"
                                            [columnDef]="communityPayeeColumns"
                                            [showClearButton]="true"
                                            [navigateToCommunity]="true"
                                            [placeholder]="'Select Community...'"
                                            [showHeaderFilters]="true"
                                            (gridSelectionEvent)="onCommunityPayeeSelection($event)"
                                        ></app-multi-column-selector>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxi-location [row]="3" [col]="1"></dxi-location>
                        <div *dxTemplate>
                            <div class="button-row-container">
                                <div class="icon-button-content">
                                    <i
                                        title="Vendor Instructions"
                                        class="fas fa-info-circle"
                                        [ngClass]="{
                                            'icon-button dx-theme-accent-as-text-color': isVendorInstructionsAvailable,
                                            'icon-disabled-button dx-theme-border-color-as-text-color':
                                                !isVendorInstructionsAvailable
                                        }"
                                        (click)="onVendorInstructionsClick()"
                                    ></i>
                                </div>
                                <div *ngIf="!selectedVendorPayee" class="icon-button-content">
                                    <i
                                        title="Vendor Notes"
                                        class="fa-2x dx-theme-border-color-as-text-color"
                                        [ngClass]="iconEmptyNotes"
                                    ></i>
                                </div>
                                <div
                                    *ngIf="!!selectedVendorPayee && !selectedVendorPayee.hasNotes"
                                    class="icon-button-content"
                                >
                                    <i
                                        title="Vendor Notes"
                                        class="fa-2x icons dx-theme-accent-as-text-color"
                                        [ngClass]="iconEmptyNotes"
                                        (click)="onVendorNotesClick()"
                                    ></i>
                                </div>
                                <div
                                    *ngIf="!!selectedVendorPayee && !!selectedVendorPayee.hasNotes"
                                    class="icon-button-content"
                                >
                                    <i
                                        title="Vendor Notes"
                                        class="fa-2x icons cc-icon-check icon-button"
                                        [ngClass]="iconNotes"
                                        (click)="onVendorNotesClick()"
                                    ></i>
                                </div>

                                <div class="button-content">
                                    <dx-button
                                        type="default"
                                        text="Vendor History"
                                        [icon]="iconHistory"
                                        [tabIndex]="-1"
                                        [disabled]="!isVendorSelected || isBranchVendor"
                                        [elementAttr]="{ class: 'button-size' }"
                                        (onClick)="onVendorHistoryClick()"
                                    ></dx-button>
                                </div>
                            </div>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxi-location [row]="4" [col]="0"></dxi-location>
                        <div *dxTemplate>
                            <div class="row-container">
                                <div class="first-item">
                                    <div
                                        class="field-label"
                                        [ngClass]="{
                                            'dx-theme-text-color': !isVendorAccountDisabled,
                                            'dx-theme-border-color-as-text-color': isVendorAccountDisabled
                                        }"
                                    >
                                        Vendor Account#
                                        <ng-container *ngIf="isVendorAccountRequired && !isVendorAccountDisabled">
                                            <sup class="field-star">*</sup>
                                        </ng-container>
                                    </div>
                                    <div class="field-component">
                                        <app-multi-column-selector
                                            #vendorAccountSelector
                                            [name]="'Account'"
                                            [isItemSelectionMandatory]="isVendorAccountRequired && !isVendorAccountDisabled"
                                            [disabled]="isVendorAccountDisabled"
                                            [gridSource]="vendorAccountSource"
                                            [boxValue]="vendorAccountBoxValue"
                                            [dropDownButtonTemplate]="vendorAccountDropDownButtonTemplate"
                                            [dropDownOptions]="{ width: 700 }"
                                            [valueExpr]="'id'"
                                            [displayExpr]="'accountNumber'"
                                            [columnDef]="vendorAccountColumns"
                                            [showClearButton]="false"
                                            [placeholder]="'Search Vendor Account...'"
                                            (gridSelectionEvent)="onVendorAccountSelection($event)"
                                            (editTemplateEvent)="onAccountEditClick()"
                                            (refreshSourceEvent)="onRefreshAccountEditSource()"
                                            (addTemplateEvent)="onAddVendorAccountClick()"
                                        ></app-multi-column-selector>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxi-location [row]="4" [col]="1"></dxi-location>
                        <div *dxTemplate>
                            <div class="button-row-container">
                                <div class="icon-button-content" id="copyButton">
                                    <i
                                        title="Click to copy Vendor Account"
                                        class="fas fa-copy"
                                        [ngClass]="{
                                            'icon-button dx-theme-accent-as-text-color': !!selectedVendorAccount,
                                            'icon-disabled-button dx-theme-border-color-as-text-color':
                                                !selectedVendorAccount
                                        }"
                                        (click)="onVendorAccountCopyClick()"
                                    ></i>
                                    <dx-tooltip
                                        target="#copyButton"
                                        [(visible)]="isCopyClicked"
                                        [closeOnOutsideClick]="false"
                                    >
                                        <div *dxTemplate="let data of 'content'">
                                            Vendor Account Copied To Clipboard
                                        </div>
                                    </dx-tooltip>
                                </div>

                                <div class="button-content">
                                    <dx-button
                                        type="default"
                                        text="Account History"
                                        [icon]="iconHistory"
                                        [tabIndex]="-1"
                                        [disabled]="!selectedVendorAccountId || isBranchVendor"
                                        [elementAttr]="{ class: 'button-size' }"
                                        (onClick)="onAccountHistoryClick()"
                                    ></dx-button>
                                </div>
                            </div>
                        </div>
                    </dxi-item>
                </dx-responsive-box>
            </div>
        </dxi-item>

        <dxi-item baseSize="auto" class="each-item">
            <div *dxTemplate>
                <div class="field-set-container">
                    <fieldset
                        class="field-set"
                        [ngClass]="{
                            'dx-theme-text-color': !isVendorAccountDisabled,
                            'dx-theme-border-color-as-text-color': isVendorAccountDisabled
                        }"
                    >
                        <legend>Vendor Bill To</legend>
                        <span [innerHTML]="vendorBillToAddress"></span>
                        <div class="dx-field-value">
                            <dx-switch
                                switchedOnText="Does not match"
                                switchedOffText="Match"
                                [disabled]="isVendorAccountDisabled"
                                [(value)]="workFlowEditor.vendorBillToNotMatch"
                                [elementAttr]="{ class: 'field-switch' }"
                            ></dx-switch>
                        </div>
                    </fieldset>
                    <fieldset
                        class="field-set"
                        [ngClass]="{
                            'dx-theme-text-color': !isVendorAccountDisabled,
                            'dx-theme-border-color-as-text-color': isVendorAccountDisabled
                        }"
                    >
                        <legend>Vendor Remit To</legend>
                        <span [innerHTML]="vendorRemitAddress"></span>
                        <div class="dx-field-value">
                            <dx-switch
                                switchedOnText="Does not match"
                                switchedOffText="Match"
                                [disabled]="isVendorAccountDisabled"
                                [(value)]="workFlowEditor.vendorRemitToNotMatch"
                                [elementAttr]="{ class: 'field-switch' }"
                            ></dx-switch>
                        </div>
                    </fieldset>
                </div>
            </div>
        </dxi-item>

        <dxi-item [ratio]="2" class="each-item">
            <div *dxTemplate>
                <dx-responsive-box width="100%" height="100%" class="invoice-reponsive-box cc-invoice-reponsive-box">
                    <dxi-row></dxi-row>
                    <dxi-row></dxi-row>
                    <dxi-row></dxi-row>
                    <dxi-row></dxi-row>
                    <dxi-row></dxi-row>
                    <dxi-row></dxi-row>
                    <dxi-row></dxi-row>

                    <dxi-col [ratio]="1"></dxi-col>
                    <dxi-col [ratio]="1"></dxi-col>
                    <dxi-col [ratio]="1"></dxi-col>

                    <dxi-item>
                        <dxi-location [row]="0" [col]="0"></dxi-location>
                        <div *dxTemplate>
                            <div class="row-container">
                                <div class="first-item">
                                    <div
                                        class="field-label"
                                        [ngClass]="{
                                            'dx-theme-text-color': isCommunitySelected,
                                            'dx-theme-border-color-as-text-color':
                                                !isCommunitySelected || !workFlowEditor?.allowProcessing
                                        }"
                                    >
                                        Invoice Date
                                        <sup class="field-star">*</sup>
                                    </div>
                                    <div class="field-component">
                                        <dx-date-box
                                            #invoiceDate
                                            type="date"
                                            [min]="minimumInvoiceDate"
                                            [disabled]="!isCommunitySelected || !workFlowEditor?.allowProcessing"
                                            [showClearButton]="true"
                                            [elementAttr]="{ class: 'date-box' }"
                                            [(value)]="workFlowEditor.invoiceDate"
                                            (onValueChanged)="onInvoiceDateChanged()"
                                        ></dx-date-box>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxi-location [row]="0" [col]="1"></dxi-location>
                        <div *dxTemplate>
                            <div class="row-container">
                                <div class="first-item">
                                    <div
                                        class="field-label-padding"
                                        [ngClass]="{
                                            'dx-theme-text-color': isCommunitySelected,
                                            'dx-theme-border-color-as-text-color':
                                                !isCommunitySelected || !workFlowEditor?.allowProcessing
                                        }"
                                    >
                                        Due Date
                                        <sup class="field-star">*</sup>
                                    </div>
                                    <div class="field-component">
                                        <dx-date-box
                                            #dueDate
                                            type="date"
                                            [min]="minimumInvoiceDate"
                                            [disabled]="!isCommunitySelected || !workFlowEditor?.allowProcessing"
                                            [showClearButton]="true"
                                            [elementAttr]="{ class: 'date-box' }"
                                            [(value)]="workFlowEditor.dueDate"
                                        ></dx-date-box>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxi-location [row]="0" [col]="2"></dxi-location>
                        <div *dxTemplate>
                            <div class="row-container">
                                <div class="first-item">
                                    <div
                                        class="field-small-label"
                                        [ngClass]="{
                                            'dx-theme-text-color': isCommunitySelected,
                                            'dx-theme-border-color-as-text-color':
                                                !isCommunitySelected || !workFlowEditor?.allowProcessing
                                        }"
                                    >
                                        Late Fee
                                    </div>
                                    <div class="field-multi-component">
                                        <dx-switch
                                            switchedOnText="Yes"
                                            switchedOffText="No"
                                            [disabled]="!isCommunitySelected || !workFlowEditor?.allowProcessing"
                                            [(value)]="lateFeeCheck"
                                            [elementAttr]="{ class: 'field-switch' }"
                                        ></dx-switch>
                                        <dx-number-box
                                            [disabled]="
                                                !isCommunitySelected ||
                                                !workFlowEditor?.allowProcessing ||
                                                !lateFeeCheck
                                            "
                                            [elementAttr]="{ class: 'small-text-input' }"
                                            [showClearButton]="true"
                                            [showSpinButtons]="false"
                                            [(format)]="currencyFormat"
                                            [(value)]="workFlowEditor.lateFee"
                                        >
                                            <dx-validator>
                                                <dxi-validation-rule
                                                    type="required"
                                                    message="Late Fee is required"
                                                ></dxi-validation-rule>
                                            </dx-validator>
                                        </dx-number-box>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxi-location [row]="1" [col]="0"></dxi-location>
                        <div *dxTemplate>
                            <div class="row-container">
                                <div class="first-item">
                                    <div
                                        class="field-label"
                                        [ngClass]="{
                                            'dx-theme-text-color': isCommunitySelected,
                                            'dx-theme-border-color-as-text-color':
                                                !isCommunitySelected || !workFlowEditor?.allowProcessing
                                        }"
                                    >
                                        Invoice Number
                                        <sup class="field-star">*</sup>
                                    </div>
                                    <div class="field-component">
                                        <dx-text-box
                                            #invoiceNumber
                                            [disabled]="!isCommunitySelected || !workFlowEditor?.allowProcessing"
                                            [elementAttr]="{ class: 'text-input' }"
                                            [(value)]="workFlowEditor.invoiceNumber"
                                        >
                                            <dx-validator>
                                                <dxi-validation-rule
                                                    type="required"
                                                    message="Invoice Number is required"
                                                ></dxi-validation-rule>
                                            </dx-validator>
                                        </dx-text-box>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxi-location [row]="1" [col]="1"></dxi-location>
                        <div *dxTemplate>
                            <div class="button-row-container">
                                <div class="icon-button-content">
                                    <i
                                        title="Click to paste copied text"
                                        class="fas fa-paste"
                                        [ngClass]="{
                                            'icon-button dx-theme-accent-as-text-color': !!copiedText,
                                            'icon-disabled-button dx-theme-border-color-as-text-color': !copiedText
                                        }"
                                        (click)="onInvoiceNumberPasteClick()"
                                    ></i>
                                </div>
                                <div class="button-content">
                                    <dx-button
                                        type="default"
                                        text="Invoice History"
                                        [icon]="iconHistory"
                                        [tabIndex]="-1"
                                        [disabled]="!workFlowEditor?.invoiceNumber"
                                        [elementAttr]="{ class: 'button-size' }"
                                        (onClick)="onInvoiceHistoryClick()"
                                    ></dx-button>
                                </div>
                            </div>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxi-location [row]="1" [col]="2"></dxi-location>
                        <div *dxTemplate>
                            <div class="row-container">
                                <div class="first-item">
                                    <div
                                        class="field-label-padding"
                                        [ngClass]="{
                                            'dx-theme-text-color': isCommunitySelected,
                                            'dx-theme-border-color-as-text-color':
                                                !isCommunitySelected || !workFlowEditor?.allowProcessing
                                        }"
                                    >
                                        Handling
                                        <sup class="field-star">*</sup>
                                    </div>
                                    <div class="field-component">
                                        <dx-select-box
                                            #specialHandling
                                            displayExpr="displayText"
                                            valueExpr="specialHandlingId"
                                            [disabled]="!isCommunitySelected || !workFlowEditor?.allowProcessing"
                                            [elementAttr]="{ class: 'select-box' }"
                                            [showClearButton]="true"
                                            [searchEnabled]="true"
                                            [dataSource]="specialHandlingSource"
                                            [(value)]="workFlowEditor.specialHandlingId"
                                            (onValueChanged)="onSpecialHandlingValueChange()"
                                        ></dx-select-box>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxi-location [row]="2" [col]="0" [colspan]="3"></dxi-location>
                        <div *dxTemplate>
                            <div class="row-container">
                                <div class="first-item">
                                    <div
                                        [ngClass]="{
                                            'dx-theme-text-color': isCommunitySelected,
                                            'dx-theme-border-color-as-text-color':
                                                !isCommunitySelected || !workFlowEditor?.allowProcessing,
                                            'field-medium-label': !separateWindow,
                                            'field-large-label': separateWindow
                                        }"
                                    >
                                        Description
                                    </div>
                                    <div class="field-component">
                                        <dx-text-box
                                            #description
                                            [disabled]="!isCommunitySelected || !workFlowEditor?.allowProcessing"
                                            [elementAttr]="{ class: 'text-input' }"
                                            [(value)]="workFlowEditor.description"
                                            (onValueChanged)="onDescriptionChanged($event)"
                                        ></dx-text-box>
                                    </div>
                                </div>
                                <div class="icon-button-content">
                                    <i
                                        title="Click to paste copied text"
                                        class="fas fa-paste"
                                        [ngClass]="{
                                            'icon-button dx-theme-accent-as-text-color': !!copiedText,
                                            'icon-disabled-button dx-theme-border-color-as-text-color': !copiedText
                                        }"
                                        (click)="onDescriptionPasteClick()"
                                    ></i>
                                </div>
                            </div>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxi-location [row]="3" [col]="0"></dxi-location>
                        <div *dxTemplate>
                            <div class="row-container">
                                <div class="first-item">
                                    <div
                                        class="field-label"
                                        [ngClass]="{
                                            'dx-theme-text-color': isCommunitySelected,
                                            'dx-theme-border-color-as-text-color':
                                                !isCommunitySelected || !workFlowEditor?.allowProcessing
                                        }"
                                    >
                                        Amount To Pay
                                        <sup class="field-star">*</sup>
                                    </div>
                                    <div class="field-component">
                                        <dx-number-box
                                            [disabled]="!isCommunitySelected || !workFlowEditor?.allowProcessing"
                                            [elementAttr]="{ class: 'number-text-input' }"
                                            [showClearButton]="true"
                                            [showSpinButtons]="false"
                                            [format]="currencyFormat"
                                            [(value)]="workFlowEditor.amount"
                                            (onValueChanged)="onAmountToPayChanged($event)"
                                        >
                                            <dx-validator>
                                                <dxi-validation-rule
                                                    type="required"
                                                    message="Amount To Pay is required"
                                                ></dxi-validation-rule>
                                            </dx-validator>
                                        </dx-number-box>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxi-location [row]="3" [col]="1"></dxi-location>
                        <div *dxTemplate>
                            <div class="row-container">
                                <div class="first-item">
                                    <div
                                        class="field-long-label"
                                        [ngClass]="{
                                            'dx-theme-text-color': isCommunitySelected,
                                            'dx-theme-border-color-as-text-color':
                                                !isCommunitySelected || !workFlowEditor?.allowProcessing
                                        }"
                                    >
                                        Total Invoice Amount
                                        <sup class="field-star">*</sup>
                                    </div>
                                    <div class="field-component">
                                        <dx-number-box
                                            [disabled]="!isCommunitySelected || !workFlowEditor?.allowProcessing"
                                            [elementAttr]="{ class: 'number-text-input' }"
                                            [showClearButton]="true"
                                            [showSpinButtons]="false"
                                            [format]="currencyFormat"
                                            [(value)]="workFlowEditor.invoiceAmount"
                                        >
                                            <dx-validator>
                                                <dxi-validation-rule
                                                    type="required"
                                                    message="Total Invoice Amount is required"
                                                ></dxi-validation-rule>
                                            </dx-validator>
                                        </dx-number-box>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxi-location [row]="3" [col]="2"></dxi-location>
                        <div *dxTemplate>
                            <div class="row-container">
                                <div class="first-item">
                                    <div
                                        class="field-label-padding"
                                        [ngClass]="{
                                            'dx-theme-text-color': isCommunitySelected,
                                            'dx-theme-border-color-as-text-color':
                                                !isCommunitySelected || !workFlowEditor?.allowProcessing
                                        }"
                                    >
                                        EFT Account
                                    </div>
                                    <div class="field-component">
                                        <dx-switch
                                            switchedOnText="Yes"
                                            switchedOffText="No"
                                            [disabled]="
                                                !isCommunitySelected ||
                                                !workFlowEditor?.allowProcessing ||
                                                isEFTDisabled
                                            "
                                            [elementAttr]="{ class: 'field-switch' }"
                                            [(value)]="workFlowEditor.isEFTAccount"
                                            (onValueChanged)="onEFTValueChanged($event)"
                                        ></dx-switch>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxi-location [row]="4" [col]="0" [colspan]="3"></dxi-location>
                        <div *dxTemplate>
                            <div class="right-button-row-container">
                                <div class="button-content">
                                    <dx-button
                                        icon="plus"
                                        type="default"
                                        text="New Line Item"
                                        [tabIndex]="-1"
                                        [disabled]="!isCommunitySelected || !workFlowEditor?.allowProcessing"
                                        (onClick)="onAddNewRowToWorkflowGrid()"
                                    ></dx-button>
                                </div>

                                <div class="button-content" *ngIf="!isVendorAccountDisabled">
                                    <dx-button
                                        icon="fas fa-arrow-alt-circle-down"
                                        type="default"
                                        text="Default Line Items"
                                        [tabIndex]="-1"
                                        [disabled]="defaultLineItems.length === 0"
                                        (onClick)="onDefaultLineItems()"
                                    ></dx-button>
                                </div>

                                <div class="button-content" *ngIf="wfItemsDataGridSource.length > 0">
                                    <dx-button
                                        type="default"
                                        text="Prorate Tax / Charges"
                                        [tabIndex]="-1"
                                        (onClick)="onProrateTaxChanges()"
                                    ></dx-button>
                                </div>
                            </div>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxi-location [row]="5" [col]="0" [colspan]="3"></dxi-location>
                        <div *dxTemplate>
                            <div class="row-container">
                                <div class="field-component">
                                    <dx-data-grid
                                        #workflowDataGrid
                                        keyExpr="sequence"
                                        height="100%"
                                        [disabled]="!isCommunitySelected || !workFlowEditor?.allowProcessing"
                                        [dataSource]="wfItemsDataGridSource"
                                        [showBorders]="true"
                                        [showColumnLines]="true"
                                        [showRowLines]="true"
                                        [hoverStateEnabled]="true"
                                        [columnAutoWidth]="true"
                                        [repaintChangesOnly]="true"
                                        [highlightChanges]="true"
                                        [elementAttr]="{ class: 'workflow-grid-component' }"
                                        (onRowUpdated)="onRowUpdated($event)"
                                    >
                                        <dxo-selection mode="single"></dxo-selection>
                                        <dxo-editing
                                            mode="cell"
                                            refreshMode="full"
                                            selectTextOnEditStart="true"
                                            [allowUpdating]="true"
                                            [useIcons]="true"
                                        ></dxo-editing>

                                        <dxi-column
                                            caption="Action"
                                            cellTemplate="actionCellTemplate"
                                            [width]="50"
                                        ></dxi-column>
                                        <dxi-column
                                            dataField="sequence"
                                            caption="Item#"
                                            dataType="number"
                                            [width]="50"
                                            [allowEditing]="false"
                                        ></dxi-column>
                                        <dxi-column
                                            dataField="itemAmount"
                                            caption="Amount"
                                            dataType="number"
                                            [format]="currencyFormat"
                                            [width]="120"
                                        ></dxi-column>
                                        <dxi-column
                                            dataField="description"
                                            caption="Description"
                                            [width]="auto"
                                        ></dxi-column>

                                        <dxo-summary>
                                            <dxi-total-item
                                                column="itemAmount"
                                                name="itemAmount"
                                                summaryType="sum"
                                                [customizeText]="customizeLineItemSummary"
                                            ></dxi-total-item>
                                        </dxo-summary>

                                        <div *dxTemplate="let d of 'actionCellTemplate'">
                                            <dx-button
                                                type="danger"
                                                [icon]="iconDelete"
                                                (click)="onDeleteFromWorkflowGrid(d.data)"
                                            ></dx-button>
                                        </div>
                                    </dx-data-grid>
                                </div>
                            </div>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxi-location [row]="6" [col]="0"></dxi-location>
                        <div *dxTemplate>
                            <div class="left-button-row-container">
                                <div class="dropdown-button-content">
                                    <dx-drop-down-button
                                        text="AAP Workflow Actions"
                                        icon="runner"
                                        itemTemplate="dropdownItemTemplate"
                                        [dropDownOptions]="{ width: 230 }"
                                        [elementAttr]="{ class: 'dropdown-button' }"
                                        [tabIndex]="-1"
                                        [disabled]="!isCommunitySelected || !workFlowEditor?.allowProcessing"
                                        [items]="workflowOptions"
                                        (onItemClick)="onWorkflowOptionSelection($event)"
                                    >
                                        <div *dxTemplate="let item of 'dropdownItemTemplate'">
                                            <dx-button
                                                [tabIndex]="-1"
                                                [elementAttr]="{ class: 'dropdown-menu-button' }"
                                                [icon]="item.icon"
                                                [text]="item.text"
                                                [visible]="item.visible"
                                                [type]="item.type"
                                                [hint]="item.text"
                                            ></dx-button>
                                        </div>
                                    </dx-drop-down-button>
                                </div>
                            </div>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxi-location [row]="6" [col]="1" [colspan]="2"></dxi-location>
                        <div *dxTemplate>
                            <div class="right-button-row-container">
                                <div class="right-button-row-container" *ngIf="!isPopupMode">
                                    Process & load next AAP Workflow
                                    <div class="button-content">
                                        <dx-switch
                                            switchedOnText="Yes"
                                            switchedOffText="No"
                                            width="70%"
                                            height="100%"
                                            [(value)]="continuousProcessMode"
                                        ></dx-switch>
                                    </div>
                                </div>
                                <div class="button-content">
                                    <dx-button
                                        icon="check"
                                        type="success"
                                        text="Verify & Approve"
                                        [tabIndex]="-1"
                                        [disabled]="!isCommunitySelected || !workFlowEditor?.allowProcessing"
                                        (onClick)="onVerifyAndApprove()"
                                    ></dx-button>
                                </div>
                                <div class="button-content">
                                    <dx-button
                                        type="default"
                                        [icon]="iconClose"
                                        [text]="getWorkFlowCloseLabel()"
                                        [tabIndex]="-1"
                                        (onClick)="onWorkflowClose()"
                                    ></dx-button>
                                </div>
                            </div>
                        </div>
                    </dxi-item>
                </dx-responsive-box>
            </div>
        </dxi-item>
    </dx-box>
</dx-scroll-view>
<!-- Pop up IVA History-->
<app-workflow-iva-history
    *ngIf="showHistoryPopUp"
    [mode]="historyMode"
    [title]="historyPopUpTitle"
    [payee]="selectedPayeeName"
    [workflowId]="workflowEditor?.workflowId"
    [vendorAccountNumber]="selectedVendorAccount?.accountNumber"
    [communityId]="selectedCommunity?.communityId"
    [vendorHistoryBaseParams]="vendorHistoryBaseParams"
    [vendorAccountHistoryBaseParams]="vendorAccountHistoryBaseParams"
    [invoiceHistoryBaseParams]="invoiceHistoryBaseParams"
    (closeIVAHistory)="onHistoryPopUpClose()"
></app-workflow-iva-history>

<!-- AAP Workflow History-->
<app-workflow-history
    *ngIf="showWorkFlowHistoryPopUp"
    [workflowId]="workflowId"
    [communityId]="selectedCommunity.communityId"
    (onClose)="onWorkflowHistoryPopUpClose()"
></app-workflow-history>

<!-- Notes Editor -->
<app-workflow-notes-editor
    *ngIf="showWorkFlowNotesPopUp"
    [workflowId]="workflowId"
    [hasNotes]="workFlowEditor.hasNotes"
    [communityId]="communityId"
    (closeNotesPopUp)="onWorkflowNotesPopClose($event)"
></app-workflow-notes-editor>

<!-- AAP Workflow Vendor Notes Viewer -->
<app-workflow-data-entry-vendor-notes-viewer
    *ngIf="showVendorNotesPopUp"
    [visible]="showVendorNotesPopUp"
    [workflowId]="workflowId"
    [workflowStatus]="workFlowEditor.status"
    [communityId]="selectedCommunity.communityId"
    [vendorName]="selectedVendorPayee.vendorName"
    [payeeCode]="selectedVendorPayee.vendorCode"
    (closeNotesPopUp)="onVendorNotesPopClose()"
></app-workflow-data-entry-vendor-notes-viewer>

<!-- Instruction Pop up-->
<dx-popup
    minWidth="150px"
    minHeight="150px"
    width="50%"
    height="40%"
    title="Coding Instructions for {{ selectedVendorPayee?.vendorName }}"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="showWorkFlowVendorInstructionsPopUp"
    (onHidden)="onVendorInstructionPopUpClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view width="100%" height="100%" direction="vertical" [scrollByContent]="true" [scrollByThumb]="true">
            {{ selectedVendorPayee.vendorInstructions }}
        </dx-scroll-view>
    </div>
</dx-popup>

<!-- Delete AAP Workflow -->
<app-workflow-delete
    *ngIf="showDeleteWorkflowPopUp"
    [workflowId]="workflowId"
    (onDeleteWorkflow)="onDeleteWorkflow($event)"
    (onClose)="onDeleteWorkflowClose()"
></app-workflow-delete>

<!-- Replace AAP Workflow-->
<dx-popup
    #replaceInvoicePopup
    minWidth="150px"
    minHeight="70px"
    width="30%"
    height="20%"
    title="Replace Invoice"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="showReplaceInvoiceFilePopUp"
    (onHidden)="onReplaceInvoicePopUpClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div class="replace-invoice-attachment-container">
                    <dx-file-uploader
                        class="replace-invoice-fileuploader"
                        selectButtonText="Select Invoice"
                        labelText="Invoice"
                        accept="application/pdf"
                        uploadFailedMessage="Upload successful"
                        uploadMode="instantly"
                        [(value)]="invoiceAttachments"
                    ></dx-file-uploader>
                </div>
            </dxi-item>

            <dxi-item baseSize="auto">
                <div class="popup-button-row-container">
                    <div class="left-container">
                        <dx-button
                            type="default"
                            text="Cancel"
                            [icon]="iconClose"
                            (onClick)="onReplaceInvoicePopUpClose()"
                        ></dx-button>
                    </div>

                    <div class="right-container">
                        <dx-button
                            type="success"
                            icon="check"
                            text="Submit"
                            [disabled]="invoiceAttachments.length === 0"
                            (onClick)="onReplaceInvoiceSubmit()"
                        ></dx-button>
                    </div>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<!-- Prorate Tax -->
<dx-popup
    #prorateTaxWorkflowPopup
    minWidth="150px"
    minHeight="70px"
    width="30%"
    height="20%"
    title="Prorate Tax / Service Charges"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="showProrateTaxChanges"
    (onHidden)="onProrateTaxChangesClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col" class="prorate-workflow-popup">
            <dxi-item baseSize="auto">
                <div class="extra-padding">Amount</div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-number-box
                        [elementAttr]="{ class: 'number-text-input' }"
                        [(format)]="currencyFormat"
                        [showClearButton]="true"
                        [showSpinButtons]="false"
                        [(value)]="prorateAmount"
                    >
                        <dx-validator>
                            <dxi-validation-rule
                                type="required"
                                message="Prorate Amount is required"
                            ></dxi-validation-rule>
                        </dx-validator>
                    </dx-number-box>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div class="popup-button-row-container">
                    <div class="left-container">
                        <dx-button
                            type="default"
                            text="Cancel"
                            [icon]="iconClose"
                            (onClick)="onProrateTaxChangesClose()"
                        ></dx-button>
                    </div>

                    <div class="right-container">
                        <dx-button
                            class="button-content"
                            type="success"
                            text="Prorate"
                            [disabled]="!prorateAmount"
                            [icon]="iconCheck"
                            (onClick)="onProrateTaxSubmit()"
                        ></dx-button>
                    </div>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<!-- Manage Vendor Accounts -->

<app-manage-vendor-accounts
    #manageVendorAccount
    *ngIf="showManageVendorAccountPopup"
    [workflowId]="workflowId"
    [workflowStatus]="workFlowEditor?.status"
    [vendorCode]="selectedVendorPayee?.vendorCode"
    [vendorName]="selectedVendorPayee?.vendorName"
    [associationVendorId]="selectedVendorPayee?.vendorBranchAssociationId"
    [communityId]="selectedCommunity?.communityId"
    [communityName]="selectedCommunity?.communityName"
    (closeManageVendorAccounts)="onManageVendorAccountClose()"
    (onVendorAccountEditorClick)="onVendorAccountSelectionForEditor($event)"
></app-manage-vendor-accounts>

<app-vendor-account-editor
    #vendorAccountEditorConfig
    *ngIf="showAddEditVendorAccount"
    [title]="addEditVendorAccountPopUpTitle"
    [configMode]="vendorAccountConfigMode"
    [communityId]="selectedCommunity?.communityId"
    [vendorName]="selectedVendorPayee?.vendorName"
    [associationVendorId]="selectedVendorPayee?.vendorBranchAssociationId"
    [vendorAccount]="selectedVendorAccountForEditor"
    (closeVendorAccount)="onVendorAccountEditorClose($event)"
></app-vendor-account-editor>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#workflow' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<cc-message-box #workflowMessageBox></cc-message-box>
